export default "__VITE_ASSET__c47277d4__"